import pick from 'lodash.pick';
import {convertDecimal2} from "../helpers";

const returnEmptyIfUndefinedOrNull = value => {
  if (value === undefined || value === null) {
    return '';
  } else {
    return value;
  }
};

const quoteState = (costStateName, effectiveDate) => {
  const name = returnEmptyIfUndefinedOrNull (costStateName);
  const date = effectiveDate ? ` on ${effectiveDate}` : '';

  return name + date;
};

export const getQuoteStateTargetDates = (quoteStateTargetDates, headerName) => {
  if (!quoteStateTargetDates || quoteStateTargetDates.length === 0) return '';

  const quoteState = quoteStateTargetDates.find (
    element => element.costsheetQuoteStateforTargetDesc === headerName
  );

  return quoteState && quoteState.costsheetQuoteStateTargetDate
    ? quoteState.costsheetQuoteStateTargetDate
    : '';
};

export const mappedHeaderValues = CBDHeader => {
  return {
    Model: returnEmptyIfUndefinedOrNull (CBDHeader.nikeModelId),
    Gender: returnEmptyIfUndefinedOrNull (CBDHeader.nikeGender),
    'Age Group': returnEmptyIfUndefinedOrNull (CBDHeader.ageName),
    'Costing Size': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetCostingSize
    ),
    'Dev Team': returnEmptyIfUndefinedOrNull (CBDHeader.nikeDevelopmentTeam),
    'Sample ID': returnEmptyIfUndefinedOrNull (CBDHeader.nikeSampleId),
    'Quote State Effective Date': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetQuoteStateActualDate
    ),
    'Ready for Review Date': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetReadyForReviewDate
    ),
    'Reviewed Due Date': getQuoteStateTargetDates (
      CBDHeader.costsheetQuoteStateTargetDate,
      'Reviewed Due Date'
    ),
    'Ready for Review Due Date': getQuoteStateTargetDates (
      CBDHeader.costsheetQuoteStateTargetDate,
      'Ready For Review Due Date'
    ),
    'Confirmed Due Date': getQuoteStateTargetDates (
      CBDHeader.costsheetQuoteStateTargetDate,
      'Confirmed Due Date'
    ),
    'BOM Cost State': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetBomCostState
    ) && returnEmptyIfUndefinedOrNull (CBDHeader.costsheetBomCostStateDate)
      ? `${CBDHeader.costsheetBomCostState} on ${CBDHeader.costsheetBomCostStateDate}`
      : '',
    'BOL Cost State': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetBolCostState
    )
      ? `${CBDHeader.costsheetBolCostState}${CBDHeader.costsheetBolCostStateDate ? ` on ${CBDHeader.costsheetBolCostStateDate}` : ''}`
      : '',
    'CBD ID': returnEmptyIfUndefinedOrNull (CBDHeader.costsheetIdentifier),
    'CBD Version Number': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetVersionNumber
    ),
    'Cost Sheet ID': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetPcxCostSheetIdentifier
    ),
    'Cost Sheet Status': returnEmptyIfUndefinedOrNull (
          CBDHeader.costsheetPcxCostSheetStatus
    ),
    'Cost Sheet Version': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetPcxCostSheetVersionNumber
    ),
    'BOM Name': returnEmptyIfUndefinedOrNull (CBDHeader.ptcbomPartName)
      ? CBDHeader.ptcbomPartName
      : '---',
    'BOM Version': returnEmptyIfUndefinedOrNull (
      CBDHeader['bomversionInfo.identifier.versionId']
    ),
    'BOL Name': returnEmptyIfUndefinedOrNull (CBDHeader.ptcbolPartName)
      ? CBDHeader.ptcbolPartName
      : '---',
    'BOL Version': returnEmptyIfUndefinedOrNull (
      CBDHeader['bolversionInfo.identifier.versionId']
    ),
    'Other Adjustment Cost': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetOtherCostAdjustment
    ),
    'Other Cost': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetOtherCostTotal
    ),
    'Other Adjustment Cost Description': returnEmptyIfUndefinedOrNull (
          CBDHeader.costsheetOtherCostDescription
    ),
    'Glidepath Cost': returnEmptyIfUndefinedOrNull (
          CBDHeader.costsheetGlidepathCost
      ),
    'Target FOB': returnEmptyIfUndefinedOrNull (
        CBDHeader.costsheetDevelopmentTargetFOBCost
    ),
    'Target Tooling': CBDHeader.costsheetTargetToolingCost
      ? CBDHeader.costsheetTargetToolingCost
      : '',
    'Target Material Cost' : returnEmptyIfUndefinedOrNull (
        CBDHeader.costsheetTargetMaterialCost),
    'Target Labor Cost' : returnEmptyIfUndefinedOrNull (
        CBDHeader.costsheetTargetLaborCost),
    'Target Overhead Cost' : returnEmptyIfUndefinedOrNull (
        CBDHeader.costsheetTargetOverheadCost),
    'Target Profit Cost' : returnEmptyIfUndefinedOrNull (
        CBDHeader.costsheetTargetProfitCost),
    FOB: CBDHeader.costsheetFobCost,
    'Target FOB with Tooling': returnEmptyIfUndefinedOrNull (
        CBDHeader.costsheetTargetFOBCostwithTooling),
    'Total Standard Minutes':returnEmptyIfUndefinedOrNull(
          CBDHeader.costsheetTargetStandardMinutes),
    'Total Observed Minutes':returnEmptyIfUndefinedOrNull(
          CBDHeader.costsheetTargetObservedMinutes),
    'FOB with Tooling': CBDHeader.costsheetFobWithTooling,
    'Tooling Cost': CBDHeader.costsheetToolingCost,
    'FOB Effective Date': CBDHeader.costsheetFobEffectiveDate
      ? CBDHeader.costsheetFobEffectiveDate
      : 'N/A',
    'Calculation Date': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetCalculationDate
    ),
    'Calculation Trigger Type': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetCalculationTriggerType
    ),
    'Calculation Triggered By': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetCalculationTriggeredBy
    ),
    'DUTY DRIVER': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetTargetDutyDriverDescription
    ),
    'ACTUAL DUTY DRIVER': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetActualDutyDriverDescription
    ),
    'DEV STYLE': returnEmptyIfUndefinedOrNull (CBDHeader.productName),
    'PRODUCT CODE': returnEmptyIfUndefinedOrNull (CBDHeader.nikeProductCode),
    'Product Code': returnEmptyIfUndefinedOrNull (CBDHeader.nikeProductCode),
    'Retail Price': returnEmptyIfUndefinedOrNull (CBDHeader.costsheetTargetRetailPrice?convertDecimal2(CBDHeader.costsheetTargetRetailPrice):`$0.0`),
    COLORWAY: returnEmptyIfUndefinedOrNull (CBDHeader.nikeDevColorwayDesc),
    'PRODUCTION FACTORY': returnEmptyIfUndefinedOrNull (
      CBDHeader.nikeProductionFactory
    ),
    PCC: returnEmptyIfUndefinedOrNull (CBDHeader.nikePCC),
    SEASON: returnEmptyIfUndefinedOrNull (CBDHeader.nikeSeason),
    'COSTING SEASON': returnEmptyIfUndefinedOrNull (CBDHeader.costsheetSeason),
    'EARLY OR LATE BUY INDICATOR': returnEmptyIfUndefinedOrNull (CBDHeader.costsheetIsEarlyOrLateBuyIndicator)?'YES':'NO',
    'MILESTONE (GATE)': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetCostEventName
    ),
    'QUOTE STATE': quoteState (
      CBDHeader.costsheetCostStateName,
      CBDHeader.costsheetQuoteStateActualDate
    ),
    'Quote ID': CBDHeader.costsheetQuoteIdentifier,
    FEM: returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetFactoryExcessMultiplierFemValue
    ),
    'Factory Labor Rate': typeof CBDHeader.costsheetLaborRateValuePerHour ===
      'number'
      ? CBDHeader.costsheetLaborRateValuePerHour / 60
      : '',
    'Labor Rate Effective Date': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetLaborRateEffectiveDate
    ),
    'EXCHANGE RATE STATUS': returnEmptyIfUndefinedOrNull (
      CBDHeader.exchangerateTypeName
    ),
    'EXCHANGE RATE EFFECTIVE DATE': returnEmptyIfUndefinedOrNull (
      CBDHeader.exchangerateEffectiveDate
    ),
    // 'Tooling Effective Date': returnEmptyIfUndefinedOrNull (
    //   CBDHeader.costsheetToolingEffectiveDate
    // ),
    'Material Reference Date': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetMaterialEffectivityReferenceDate
    ),
    'Labor Reference Date': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetLaborEffectivityReferenceDate
    ),
    'Overhead Reference Date': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetOverheadEffectivityReferenceDate
    ),
    'Other Overhead Percent': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetOtherOverheadPercent
    ),
    'Other Overhead Percent Effective Date': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetOtherOverheadPercentEffectiveDate
    ),
    'Profit Reference Date': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetProfitEffectivityReferenceDate
    ),
    'FEM Effective Date': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetFemEffectiveDate
    ),
    'Profit Rate Percent': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetProfitRatePercent
    ),
    'Profit Rate Percent Effective Date': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetProfitRateEffectiveDate
    ),
    'Cost Sheet Currency Code': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetCurrencyCode
    ),
    'Cost Sheet Exchange Rate': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetUsdExchangeRate
    ),
    'Cost Sheet Exchange Rate Effective Date': returnEmptyIfUndefinedOrNull (
      CBDHeader.costsheetExchangeRateReferenceDate
    ),
    'Exchange Rates': CBDHeader.exchangeratedetails
      ? CBDHeader.exchangeratedetails.map (exchangeRate => {
          return {
            'Effective Date': exchangeRate.exchangerateEffectiveDate || '',
            'Exchange Rate Status': exchangeRate.exchangerateTypeName || '',
            'Initiating Currency': exchangeRate.exchangerateInitiatingCurrency ||
              '',
            'Resulting Currency': exchangeRate.exchangerateResultingCurrency ||
              '',
            'Exchange Rate': exchangeRate.exchangeRate || '',
          };
        })
      : '',
  };
};

export const mappedHeaderSections = headerData => {
  return {
    'Product Info': pick (headerData, [
      'Model',
      'Gender',
      'Costing Size',
      'Dev Team',
      'Sample ID',
    ]),
    'Quote Info': pick (headerData, [
      'Calculation Date',
      'Calculation Trigger Type',
      'Calculation Triggered By',
      'Ready for Review Due Date',
      'Reviewed Due Date',
      'Confirmed Due Date',
      'BOM Cost State',
      'BOL Cost State',
      'Quote ID',
    ]),
    'System Info': pick (headerData, [
      'CBD ID',
      'CBD Version Number',
      'Cost Sheet Status',
      'Cost Sheet ID',
      'Cost Sheet Version',
      'BOM Name',
      'BOM Version',
      'BOL Name',
      'BOL Version',
    ]),
    costSummaryInfo: pick (headerData, [
      'DEV STYLE',
      'PRODUCT CODE',
      'COLORWAY',
      'PCC',
      'PRODUCTION FACTORY',
    ]),
    costSummaryInfo2: pick (headerData, [
      'SEASON',
      'MILESTONE (GATE)',
      'QUOTE STATE',
      'Ready for Review Date',
    ]),
  };
};

export const sumByAttribute = (arrayOfObjects, attribute) => {
  return arrayOfObjects.reduce ((sum, obj) => {
    return sum + obj[attribute];
  }, 0);
};



// WEBPACK FOOTER //
// ./src/dataMappingUIHelpers/CbdHeaderDataMapping.js